import type { Driver, Tag, TagToCreate } from '../../../../../types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { DriverMultiSelectAddDialogBody } from '../components/DriverMultiSelectAddDialogBody';
import { getAllTagsInAccount } from '../../../../Drivers.selectors';
import { getDriversRtk } from '../../../appSlice';
import type { AppDispatch, RootState } from '../../../../../configuration/setup/store';
import { setMultiSelectTagsToCreate, setMultiSelectTagToAdd } from '../../sidebar/tabs/groups/groupSlice';

export interface DriverMultiSelectAddDialogBodyPropertiesFromState {
    allTagsInAccount: Tag[];
    drivers: Driver[];
}

export interface DriverMultiSelectAddDialogBodyPropertiesFromDispatch {
    setTagsToAdd: (tag: Tag[]) => void;
    setTagsToCreate: (tagToCreate: TagToCreate[]) => void;
}

const mapStateToProps = (state: RootState): DriverMultiSelectAddDialogBodyPropertiesFromState => ({
    allTagsInAccount: getAllTagsInAccount(state),
    // biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
    drivers: getDriversRtk(state as any),
});

const mapDispatchToProps = (dispatch: AppDispatch): DriverMultiSelectAddDialogBodyPropertiesFromDispatch => ({
    setTagsToAdd(tags: Tag[]) {
        dispatch(setMultiSelectTagToAdd(tags));
    },
    setTagsToCreate(tagsToCreate: TagToCreate[]) {
        dispatch(setMultiSelectTagsToCreate(tagsToCreate));
    },
});

export const DriverMultiSelectAddDialogBodyContainer = injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(DriverMultiSelectAddDialogBody)
);
